import { type LoaderFunction, type LoaderFunctionArgs } from 'react-router-dom'
import { fetchAlbumBySlug } from '../api/listAlbums'

export const appLoader: LoaderFunction = () => {
    return {}
}

export const postPageLoader: LoaderFunction = async ({
    params,
}: LoaderFunctionArgs) => {
    const slug = params.slug
    if (!slug) {
        return new Response('Not Found', {
            status: 404,
            statusText: 'Missing slug',
        })
    }
    const item = await fetchAlbumBySlug(slug)
    if (!item) {
        return new Response('Not Found', {
            status: 404,
            statusText: `No portfolio item for slug: ${slug}`,
        })
    }
    return { item }
}
